import { create } from "zustand"

interface MedicalRecordDialogStore {
  openCloseConfirmationDialog: boolean
  setCloseConfirmationDialog: (state: boolean) => void
  shouldIncreaseMissedCall: boolean
  setShouldIncreaseMissedCall: (state: boolean) => void
}

export const useMedicalRecordDialogStore = create<MedicalRecordDialogStore>((set) => ({
  openCloseConfirmationDialog: false,
  setCloseConfirmationDialog: (state: boolean) => set({ openCloseConfirmationDialog: state }),
  shouldIncreaseMissedCall: false,
  setShouldIncreaseMissedCall: (state: boolean) => set({ shouldIncreaseMissedCall: state }),
}))
